import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'achoo-gauge-chart-placeholder',
  templateUrl: './achoo-gauge-chart-placeholder.component.html',
  styleUrls: ['./achoo-gauge-chart-placeholder.component.scss']
})
export class AchooGaugeChartPlaceholderComponent {

  @Input() title: string;

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-gauge-chart-placeholder/achoo-gauge-chart-placeholder.component.ts